// store/Plans/PlansSaga.js
import { put, call, takeLatest } from "redux-saga/effects";
import * as api from "./api";
import * as actionTypes from "../ActionTypes";
import { actionUpdateGlobalLoaderSagaAction } from "../GlobalLoader/GlobalLoaderAction";

/* ================= SAVE PLAN ================= */
function* savePlanSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { callback, ...payload } = action.payload;


    const response = yield call(api.savePlanAPI, payload);

    yield put({
      type: actionTypes.SAVE_PLAN_CHURCH_SUCCESS,
      payload: response,
    });

    callback?.({ type: 1, data: response });
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message || err.message;


    yield put({
      type: actionTypes.SAVE_PLAN_FAIL,
      payload: message,
    });

    action.payload?.callback?.({ type: 0, error: message });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

/* ================= READ PLAN ================= */
function* readPlanSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { callback, ...payload } = action.payload || {};


    const response = yield call(api.readPlanAPI, payload);

    yield put({
      type: actionTypes.READ_PLAN_CHURCH_SUCCESS,
      payload: response,
    });

    callback?.({ type: 1, data: response.data });
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message || err.message;


    yield put({
      type: actionTypes.READ_PLAN_FAIL,
      payload: message,
    });

    action.payload?.callback?.({ type: 0, error: message });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

/* ================= SAVE DAY PLAN ================= */
function* saveDayPlanSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  try {
    const { callback, ...payload } = action.payload;


    const response = yield call(api.saveDayPlanAPI, payload);

    yield put({
      type: actionTypes.SAVE_DAY_PLAN_SUCCESS,
      payload: response,
    });

    callback?.({ type: 1, data: response });
  } catch (err) {
    const message =
      err?.response?.data?.errors?.[0]?.message || err.message;


    yield put({
      type: actionTypes.SAVE_DAY_PLAN_FAIL,
      payload: message,
    });

    action.payload?.callback?.({ type: 0, error: message });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

/* ================= WATCHER ================= */
export default function* PlansWatcherSaga() {
  yield takeLatest(actionTypes.SAVE_PLAN_CHURCH_REQUEST, savePlanSaga);
  yield takeLatest(actionTypes.READ_PLAN_CHURCH_REQUEST, readPlanSaga);
  yield takeLatest(actionTypes.SAVE_DAY_PLAN_REQUEST, saveDayPlanSaga);
}
